const BRASIL_API_BANKS_URL =
  'https://brasilapi.com.br/api/banks/v1';

function normalizarBanco(banco) {
  if (
    !banco ||
    banco.code === null ||
    banco.code === undefined
  ) {
    return null;
  }

  const codigo = String(
    banco.code,
  ).trim();

  const nome = String(
    banco.fullName ||
    banco.name ||
    '',
  ).trim();

  const ispb = String(
    banco.ispb || '',
  ).trim();

  if (
    !codigo ||
    !nome ||
    !ispb
  ) {
    return null;
  }

  return {
    id: ispb,
    codigo,
    nome,
    ispb,
  };
}

export async function serviceRecuperaBancosBrasil(
  signal,
) {
  const response = await fetch(
    BRASIL_API_BANKS_URL,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      signal,
    },
  );

  if (!response.ok) {
    throw new Error(
      `Não foi possível consultar os bancos. Status HTTP: ${response.status}.`,
    );
  }

  const dados =
    await response.json();

  if (!Array.isArray(dados)) {
    throw new Error(
      'A BrasilAPI retornou uma resposta inválida para a consulta de bancos.',
    );
  }

  return dados
    .map(normalizarBanco)
    .filter(
      (banco) =>
        banco !== null,
    )
    .sort(
      (bancoA, bancoB) => {
        const codigoA =
          Number(
            bancoA.codigo,
          );

        const codigoB =
          Number(
            bancoB.codigo,
          );

        if (
          Number.isFinite(
            codigoA,
          ) &&
          Number.isFinite(
            codigoB,
          ) &&
          codigoA !== codigoB
        ) {
          return (
            codigoA -
            codigoB
          );
        }

        return bancoA
          .nome
          .localeCompare(
            bancoB.nome,
            'pt-BR',
          );
      },
    );
}